module.exports = __webpack_public_path__ + "media/images/man-profile-1-ca7733c7b1c47eba8e7e58a9f9db812c.jpeg";